import { AllTopicTypes } from 'topics';
import { ViewSettings } from 'schemas/componentSettings/viewSettings';
import { initialTopicFilterState } from 'redux/reducers/topicFilters';

export const validFiltersNames = Object.keys(initialTopicFilterState.value);

export type TopicsWithFilters =
  | AllTopicTypes
  | 'home'
  | 'search'
  | 'label'
  | 'customList'
  | 'charts'
  | 'topLists'
  | 'playlistActivity';

export interface ITopicFilterState {
  country?: string;
  streaming?: number;
  download?: number;
  media?: MediaTypes;
  region?: string;
  genre?: string[];
  release?: ReleaseTypes;
  customRegion?: string[];
  platform?: number;
}

export type TopicFilterNames = keyof ITopicFilterState;
export type TopicViewSettingNames = keyof ViewSettings;

type ApplicableTopicFilters = {
  [key in TopicsWithFilters]?: TopicFilterNames[];
};

type ApplicableTopicViewSettings = {
  [key in TopicsWithFilters]?: TopicViewSettingNames[];
};

export const viewSettingsForTopic: ApplicableTopicViewSettings = {
  home: [],
  summary: ['timeframe'],
  view: [],
  concerts: [],
  certifications: [],
  streaming: [],
  download: [],
  physical: [],
  all: [],
  dsp: [],
  official: [],
  radioCharts: [],
  radio: [],
  discoveries: [],
  territory: [],
  social: [],
  label: [],
  search: [],
  customList: [],
};

export const filtersForTopic: ApplicableTopicFilters = {
  home: [
    'country',
    'streaming',
    'download',
    'media',
    'region',
    'release',
    'genre',
    'customRegion',
  ],
  summary: ['region', 'country', 'customRegion'],
  view: [
    'country',
    'streaming',
    'download',
    'media',
    'region',
    'release',
    'customRegion',
  ],
  certifications: [],
  concerts: ['region', 'country', 'customRegion'],
  streaming: ['country', 'streaming', 'media', 'region', 'customRegion'],
  playlist: ['country', 'streaming', 'region', 'customRegion'],
  download: ['country', 'download', 'media', 'region', 'customRegion'],
  physical: ['country', 'region', 'customRegion'],
  all: ['country', 'streaming', 'download', 'media', 'region', 'customRegion'],
  positionTracker: ['country'],
  dsp: ['country'],
  official: ['country'],
  radioCharts: ['country'],
  radio: ['country', 'region', 'customRegion'],
  discoveries: ['country', 'region', 'customRegion'],
  territory: [
    'country',
    'streaming',
    'download',
    'media',
    'region',
    'customRegion',
  ],
  label: ['country', 'streaming'],
  search: [],
  customList: [
    'country',
    'streaming',
    'download',
    'region',
    'media',
    'customRegion',
  ],
  charts: ['country'],
  engagement: ['streaming'],
  shortFormVideo: ['country', 'region', 'customRegion', 'platform'],
  ageGender: ['country', 'streaming'],
  topLists: ['country', 'streaming', 'region', 'customRegion'],
  playlistActivity: ['region', 'customRegion', 'country', 'streaming'],
};

export type TimeFrames = 'twtd' | 'lw';

type MediaTypes = 'audio' | 'video' | 'all';

type ReleaseTypes = 'catalogue' | 'frontline';
